import styled from 'styled-components'

export const InputContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 18px;
	margin-bottom: 10px;

	input {
		width: 100%;
		padding: 14px 18px !important;
		border: 1.5px solid rgba(255, 255, 255, 0.15) !important;
		border-radius: 10px !important;
		font-size: 15px !important;
		background: rgba(30, 30, 45, 0.6) !important;
		transition: all 0.3s ease;
		outline: none !important;
		color: #ffffff !important;
		font-weight: 400 !important;
		letter-spacing: 0.3px !important;
		-webkit-text-fill-color: #ffffff !important;

		&::placeholder {
			color: rgba(255, 255, 255, 0.4) !important;
			font-weight: 400;
			-webkit-text-fill-color: rgba(255, 255, 255, 0.4) !important;
		}

		&:focus {
			border-color: rgba(102, 126, 234, 0.5) !important;
			background: rgba(30, 30, 45, 0.8) !important;
			box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15) !important;
			color: #ffffff !important;
		}

		&:hover:not(:focus) {
			border-color: rgba(255, 255, 255, 0.25) !important;
			background: rgba(30, 30, 45, 0.7) !important;
		}
	}
`
